import React from 'react';
import { Link } from 'react-router-dom';
import { navItems } from '../data/profile';
export function SiteFooter() {
  return <footer className="bg-navy" data-id="element-39" data-mp="3r9kgd64mjx6h">
      <div className="mx-auto max-w-dossier px-6 py-14 lg:px-10" data-id="element-40" data-mp="3ralsldxdmpps">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between" data-id="element-41" data-mp="3mg831s5ebct1">
          <div data-id="element-42" data-mp="3hhojtzi6sf4d">
            <p className="font-display text-2xl text-white" data-id="element-43" data-mp="3hi6bsjxtg76h">Samanntha DuBridge</p>
            <p className="mt-3 max-w-sm font-sans text-sm leading-relaxed text-navy-200/80" data-id="element-44" data-mp="3dhmdhd1iaxir">
              Global People Executive · Board &amp; Advisory Candidate · San Francisco Bay Area
            </p>
            <Link to="/inquire" className="mt-6 inline-block bg-emerald px-6 py-3 font-sans text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-emerald-700" data-id="element-45" data-mp="33j6yg8fr7epm">
              Board &amp; Advisory Inquiries
            </Link>
          </div>

          <nav aria-label="Footer" className="grid grid-cols-2 gap-x-12 gap-y-3 sm:grid-cols-3" data-id="element-46" data-mp="wsqsea0xfkqv">
            {[...navItems, {
            label: 'Inquire',
            to: '/inquire'
          }].map(item => <Link key={item.to} to={item.to} className="font-sans text-sm text-navy-200/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-47" data-mp="1aqpzv5oxfd1b">
                {item.label}
              </Link>)}
          </nav>
        </div>

        <p className="mt-12 font-sans text-xs text-navy-200/60" data-id="element-48" data-mp="1ohv3sjzburhg">
          © {new Date().getFullYear()} Samanntha DuBridge. Confidential executive dossier prepared
          for nominating committees and advisory boards.
        </p>
      </div>
    </footer>;
}